// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HoverPreviewController from "./hover_preview_controller"
application.register("hover-preview", HoverPreviewController)

import SearchController from "./search_controller"
application.register("search", SearchController)
